import { AppNS } from 'app';
import { FileInfo } from 'app/ui/components/multi-file-uploader/MultiFileUploader';
import { omit } from 'lodash-es';

export const parseStaffMemberAddData = (
  data: Omit<AppNS.InspectorProfile, 'id'>
): AppNS.Params => {
  return {
    ...parseStaffMemberBodyData(data),
  };
};

export const parseStaffMemberEditData = (
  data: AppNS.InspectorProfile
): AppNS.Params => {
  return {
    id: data.id,
    ...parseEditStaffMemberBodyData(data),
  };
};

export const parseStaffMemberBodyData = (
  data: AppNS.InspectorProfile | Omit<AppNS.InspectorProfile, 'id'>
): AppNS.Params => {
  const documentIds = parseStaffMemberRequestDocuments(data.documents);
  return {
    properties: {
      ...omit(data, 'id', 'documents'),
      documentIds,
    },
  };
};

export const parseEditStaffMemberBodyData = (
  data: AppNS.InspectorProfile | Omit<AppNS.InspectorProfile, 'id'>
): AppNS.Params => {
  const documentIds = parseStaffMemberRequestDocuments(data.documents);
  return {
    properties: {
      ...omit(data, 'id', 'documents', 'agencyCompanyId', 'userId'),
      documentIds,
    },
  };
};

export const parseStaffMemberRequestDocuments = (
  data: Array<FileInfo>
): Array<string> => {
  return data.map((item: FileInfo) => item.id || '');
};

export const parseStaffMemberResponseDocuments = (
  data: Array<AppNS.Params>
): Array<FileInfo> => {
  return data?.map((item: AppNS.Params) => {
    return {
      id: item.id,
      documentId: item.id,
      thumbnail: '',
      url: item.fileUrl.url,
      uppyId: '',
      name: item.file.fileName,
      isLoaded: true,
      isRemoved: false,
    };
  });
};

export const parseStaffMembersData = (
  data: Array<AppNS.Params>
): Array<AppNS.InspectorProfile> => {
  return data.map((item: AppNS.Params) => {
    const member = item;
    member.documents = parseStaffMemberResponseDocuments(item.documents);
    member.fullName = item.user?.fullName;
    member.id = item.user?.id;
    return member as AppNS.InspectorProfile;
  });
};
